import { toPlatePlugin } from '@udecode/plate/react';

import { BaseTextAlignPlugin } from '../lib/index';

export const TextAlignPlugin = toPlatePlugin(BaseTextAlignPlugin);
